export type PhoneRaw = string;

const KOREAN_MOBILE_PHONE_PATTERN = /^01[016789]\d{7,8}$/;

export const maskKoreanMobilePhone = (phone: PhoneRaw): string => {
  const rawPhone = String(phone || "").trim();
  const digits = rawPhone.replace(/\D/g, "");

  if (!KOREAN_MOBILE_PHONE_PATTERN.test(digits)) return rawPhone;

  const middleLength = digits.length - 7;
  return `${digits.slice(0, 3)}-${"*".repeat(middleLength)}-${digits.slice(-4)}`;
};
